<template>
<div id="newsletter-type-subscriber" v-if="id">
  <h2>
    Newsletter Type Subscriber #{{ id }}
  </h2>

  <newsletter-type-nav
    :newsletterTypeId="relationships.newsletter_type.id"
    :newsletterTypeSubscriberId="id"
  ></newsletter-type-nav>

  <table class="table">
    <tr>
      <td>
        User
      </td>
      <td v-if="subscription_user">
        <router-link
          :to="{
            name: 'user',
            params: {
              userId: subscription_user.attributes.id
            }
          }"
        >
          {{ subscription_user.attributes.email }}
          (#{{ subscription_user.attributes.id }})
        </router-link>
      </td>
      <td v-else>
        No user found
      </td>
    </tr>
    <tr>
      <td>
        Subscriber Email
      </td>
      <td>
        {{ subscriber_email }}
      </td>
    </tr>
    <tr>
      <td colspan="2">
        <p class="alert alert-warning" role="alert">
          This overrides any email address in the user record.
        </p>
      </td>
    </tr>
    <tr>
      <td>
        Newsletter Type
      </td>
      <td>
        <router-link
          :to="{
            to: 'newsletter_type',
            params: {
              newsletterTypeId: relationships.newsletter_type.id
            }
          }"
        >
          {{ newsletter_type.attributes.name }}
        </router-link>
      </td>
    </tr>
    <tr>
      <td>
        Subscription Token
      </td>
      <td>
        {{ subscription_token }}
      </td>
    </tr>
    <tr>
      <td>
        Current Status
      </td>
      <td>
        {{ status }}
      </td>
    </tr>
    <tr>
      <td>
        Pending At
      </td>
      <td>
        {{ pending_at }}
      </td>
    </tr>
    <tr>
      <td>
        Accepted At
      </td>
      <td>
        {{ accepted_at }}
      </td>
    </tr>
    <tr v-if="unsubscribed_at">
      <td>
        {{ unsubscribed_at }}
      </td>
    </tr>
    <tr v-if="bounced_at">
      <td>
        Bounced At
      </td>
      <td>
        {{ bounced_at }}
      </td>
    </tr>
    <tr>
      <td>
        Created At
      </td>
      <td>
        {{ created_at }}
      </td>
    </tr>
    <tr>
      <td>
        Updated At
      </td>
      <td>
        {{ updated_at }}
      </td>
    </tr>
  </table>
  <router-link
    :to="{
      name: 'edit_newsletter_type_subscriber', params: {
        newsletterTypeId: newsletterTypeId,
        newsletterTypeSubscriberId: newsletterTypeSubscriberId
      }
    }"
    tag="button"
    class="btn btn-block btn-primary"
  >
    Edit Subscriber
  </router-link>
</div>
</template>

<script>
import NewsletterTypeNav from '@/components/NewsletterTypeNav'

import NewsletterTypeSubscriberStore from '@/stores/NewsletterTypeSubscriberStore'

export default {
  data () {
    return NewsletterTypeSubscriberStore.state
  },

  components: {
    'newsletter-type-nav': NewsletterTypeNav
  },

  props: [
    'newsletterTypeId',
    'newsletterTypeSubscriberId'
  ],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet(
        '/newsletter_type_subscribers/' + this.newsletterTypeSubscriberId,
        NewsletterTypeSubscriberStore,
        true
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscriber.vue